import { put, takeLatest } from 'redux-saga/effects'
import request from '@utils/request'
import { rootActions } from '@app-store/slices'
import { Action } from 'redux'
import { getSubDomain } from '@utils/helpers/authHelper'

interface ITask {
    payload: any
}
interface TaskAction extends Action, ITask {}

const { onRequest, onSuccess, onFailure } = rootActions.ui.authDynamic

function* fetchDyanmicEventSaga() {
    try {
        const blackSubdomainList = ['web', 'portal', 'app', 'prodweb', 'event', 'events']
        const subdomian = getSubDomain()
        if (subdomian) {
            if (blackSubdomainList.find(item => item === subdomian)) {
                yield put(onSuccess({ sub_domain: false }))
            } else {
                const response = yield request.get(`/event/domain/${subdomian}`)
                if (response?.success) {
                    yield put(onSuccess({ sub_domain: true, ...response?.result }))
                } else {
                    yield put(onSuccess({ sub_domain: false }))
                }
            }
        } else {
            yield put(onSuccess({ sub_domain: false }))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* authDynamicSaga(): any {
    yield takeLatest<TaskAction>(onRequest, fetchDyanmicEventSaga)
}

export default authDynamicSaga
